import { Component, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { Subscription, TeardownLogic } from 'rxjs/Subscription';
import { timer } from 'rxjs/observable/timer';

import { AuthService } from '../../services/authentication/auth.service';
import { VERSION_NUMBER } from '../../services/version/version.service';

@Component({
    selector: 'app-offline',
    styleUrls: ['offline.component.css'],
    templateUrl: 'offline.component.html',
})
export class OfflineComponent implements OnDestroy {
    private _subrelease = new Subscription();
    set subrelease(sub: TeardownLogic) {
        this._subrelease.add(sub);
    }

    ShowingUpdate = false;
    readonly TimerMax = 60;
    TimerCount = this.TimerMax;

    constructor(private authSvc: AuthService, private titleSvc: Title) {
        this.titleSvc.setTitle('DELTA | System Current Unavailable');

        // Set up a subscription on Test Connection, to check for the system being available while waiting for it to resume.
        // If the user isn't logged in and we detect a new version is available, silently go ahead and reload.
        this.subrelease = timer(0, 1000).subscribe((_) => {
            this.TimerCount--;

            if (this.TimerCount === 0) {
                // Call out to test the connection.
                this.authSvc.TestConnection().subscribe(
                    (result) => {
                        // Update the status.
                        this.authSvc.SetSystemOnlineStatus(result);

                        // And reset the tick count.
                        this.TimerCount = this.TimerMax;
                    },
                    (err) => {
                        this.authSvc.SetSystemOnlineStatus({
                            Status: false,
                            SystemMessage: '',
                            DeltaVersion: VERSION_NUMBER,
                        });
                    }
                );
            }
        });
    }

    ngOnDestroy(): void {
        this._subrelease.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/offline/offline.component.ts